import { render, staticRenderFns } from "./RsaConfigurazioneAreeViewComponent.vue?vue&type=template&id=1803e843"
import script from "./RsaConfigurazioneAreeViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAreeViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports